import { defineStore } from "pinia";

export const useAuthTokenStore = defineStore("authToken", {
  state: (): { token: string } => ({ token: "" }),
  persist: true,
  actions: {
    save(token: string) {
      this.token = token;
    },
    destroy() {
      this.token = "";
    },
  },
});
